/**
 * This helper return the  GA code or an array with two or more GA codes
 */
export default () => {
  const { REACT_APP_CLIENT, REACT_APP_LOCATION } = process.env;
  switch (REACT_APP_CLIENT) {
    case 'thebentonlawfirm':
      if (REACT_APP_LOCATION === 'dallas_fortworth') {
        return [
          {
            trackingId: 'UA-126490557-2',
            gaOptions: { name: 'netmidas' },
            debug: true,
          },
          {
            trackingId: 'UA-48384237-1',
            gaOptions: { name: 'thebentonlawfirm' },
            debug: true,
          },
        ];
      }
      break;
    default:
      return '';
  }

  return '';
};
